import type { LineString } from 'geojson'
import sql, { combineSQL, preserve } from '~/prix/utils/sql'

export function complementaryRoadPathToSql(path: LineString) {
  return sql`ST_Multi(ST_SetSRID(ST_GeomFromGeoJSON(${JSON.stringify(path)}), 4326))`
}

export function complementaryRoadPointFromPathSql(
  pathSql: ReturnType<typeof complementaryRoadPathToSql>,
) {
  return sql`ST_PointOnSurface(${pathSql})`
}

export function complementaryRoadTextArrayToSql(values: string[] | null | undefined) {
  if (!values || values.length === 0) {
    return sql`CAST(ARRAY[] AS VARCHAR[])`
  }

  return sql`ARRAY[${combineSQL(
    values.map(value => sql`${value}`),
    ', ',
  )}]`
}

export function complementaryRoadJsonbToSql(value: unknown) {
  if (value === null || typeof value === 'undefined') {
    return sql`NULL`
  }

  return sql`CAST(${JSON.stringify(value)} AS JSONB)`
}

export function complementaryRoadSourceFilterExpression(sourceFilterTableAlias: string) {
  const sourceFilterTableAliasSql = preserve(sourceFilterTableAlias)

  return sql`
    TRANSLATE(
      LOWER(
        CONCAT_WS(
          ' ',
          CAST(${sourceFilterTableAliasSql}.code AS TEXT),
          ${sourceFilterTableAliasSql}.name,
          array_to_string(${sourceFilterTableAliasSql}.alternative_names, ' '),
          array_to_string(${sourceFilterTableAliasSql}.natural_alternative_names, ' '),
          ${sourceFilterTableAliasSql}.reference,
          array_to_string(${sourceFilterTableAliasSql}.old_references, ' '),
          ${sourceFilterTableAliasSql}.highway,
          ${sourceFilterTableAliasSql}.surface,
          ${sourceFilterTableAliasSql}.track_type,
          ${sourceFilterTableAliasSql}.smoothness,
          ${sourceFilterTableAliasSql}.collection_method
        )
      ),
      'áàãâäéèêẽëíìîĩïóòõôöúùûũüç',
      'aaaaaeeeeeiiiiiooooouuuuuc'
    )
  `
}

export const complementaryRoadSelectColumns = sql`
  complementary_road.id,
  complementary_road.code,
  complementary_road.client_id,
  complementary_road.municipality_id,
  complementary_road.name,
  complementary_road.alternative_names,
  complementary_road.natural_alternative_names,
  CAST(ST_AsGeoJSON(complementary_road.point) AS JSON) AS point,
  CAST(ST_AsGeoJSON(ST_LineMerge(complementary_road.path)) AS JSON) AS path,
  complementary_road.reference,
  complementary_road.old_references,
  complementary_road.number_accuracy_percentage,
  complementary_road.number_polynomial_coefficients,
  complementary_road.number_average_angle,
  complementary_road.highway,
  complementary_road.surface,
  complementary_road.track_type,
  complementary_road.smoothness,
  CAST(complementary_road.lanes AS DOUBLE PRECISION) AS lanes,
  complementary_road.one_way,
  complementary_road.collection_method,
  complementary_road.average_global_navigation_satellite_system_accuracy_meters,
  complementary_road.collection_metadata,
  complementary_road.insert_user_id,
  complementary_road.edit_user_id,
  complementary_road.source_filter,
  complementary_road.created_at,
  complementary_road.updated_at,
  complementary_road.synchronized_at,
  complementary_road.deleted_at
`
